export default {
	restaurantesArray: [],
	restaurantesTodosArray: [],
	restaurantesDirectorio: [],
	productosRestaurante: [],
	impresorasRest: [],
	ordenadoresRest: [],
	modosTpvRest: [], //todos loos modos del negocio (dashboard negocio)
	confTpvRest: [], //todas las configuracion de los tpv del negocio (dashboard negocio)
	clientesRestaurante: [],
	modoPedir: [
		{
			value: "domicilio",
			text: "Domicilio",
		},
		{
			value: "recoger",
			text: "Recoger",
		},
	],
	formasPagoDomicilio: [
		{
			value: "tarjeta_online",
			text: "Tarjeta Online",
		},
		{
			value: "tarjeta_domicilio",
			text: "Tarjeta Domicilio",
		},
		{
			value: "efectivo",
			text: "Efectivo",
		},
	],
	formasPagoDomicilioEfectivoAcepta: [5, 10, 20, 50, 100, 200],
	formasPagoRecoger: [
		{
			value: "tarjeta_online",
			text: "Tarjeta Online",
		},
		{
			value: "local",
			text: "En local",
		},
	],
	usuariosTpvRoles: [
		{
			value: "comandero",
			text: "Comandero",
		},
		{
			value: "tpv",
			text: "TPV",
		},
		{
			value: "repartidor",
			text: "Repartidor",
		},
	],
	accionesTpvAdminRestriccion: [
		{
			value: "eliminar-pedido",
			text: "Eliminar pedido",
		},
		{
			value: "eliminar-producto",
			text: "Eliminar producto",
		},
		{
			value: "abono-producto",
			text: "Abono",
		},
	],
	//reservas
	reservasConfiguracion: {},
};
